import { render, staticRenderFns } from "./allotData.vue?vue&type=template&id=6f11adfa"
import script from "./allotData.vue?vue&type=script&lang=js"
export * from "./allotData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f11adfa')) {
      api.createRecord('6f11adfa', component.options)
    } else {
      api.reload('6f11adfa', component.options)
    }
    module.hot.accept("./allotData.vue?vue&type=template&id=6f11adfa", function () {
      api.rerender('6f11adfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/role/allotData.vue"
export default component.exports